import styles from "./premarket.module.css"

const Closed = ({ message }: { message: string }) => {
  return (
    <div className={styles.container}>
      <article style={{ textAlign: "left" }}>
        <div>{message}</div>
      </article>
    </div>
  )
}

export default Closed
